export default __webpack_public_path__ + "static/media/dash_dot_circle.66f443ff.png";